import React from 'react'
import {Presenter} from './Presenter'

export const Index = () => {
  return <Presenter />
}
